const routePaths = {
  login: "/login",
  root: "/",
  view: "/view/:viewId/:mode?",
  reports: "/reports",
};

export default routePaths;
